import en from './get_started.en';

const enConfig = { en };

export default enConfig;
